<template>
  <b-sidebar
    v-if="sidebarWidth !== ''"
    id="spec-api-price-sidebar"
    bg-variant="white"
    right
    lazy
    backdrop
    no-close-on-backdrop
    no-header
    shadow
    :width="sidebarWidth"
    @shown="getData"
    @hidden="resetSidebarData"
    ref="apiSpecPriceSidebar">
    <template v-slot:default="{ hide }">
      <b-container fluid>
        <b-button-close @click="hide()"></b-button-close>
        <b-form @submit.stop.prevent="saveFormData" autocomplete="off">
          <h2 v-if="addPrice" class="my-4">Добавление спецусловия API</h2>
          <h2 v-else class="my-4">Редактирование спецусловия API</h2>
          <b-row>
            <b-col md="3">
              <b-form-group
                label="Организация"
                label-for="dealer"
                label-class="mf-label"
                :invalid-feedback="getError('dealer')"
              >
                <treeselect
                  id="dealerClient"
                  name="dealerClient"
                  :options="dealerClients"
                  v-model="clientsModel"
                  noResultsText="Ничего не найдено..."
                  :clearable=true
                  placeholder="Выбрать..."
                  :disabled="disabled || !addPrice"
                  label="Организация"
                  data-vv-as="Организация"
                  v-validate="{required:true}">
                  <div slot="value-label" slot-scope="{ node }">{{ node.raw.name }}</div>
                </treeselect>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group
                label="Месяц начала применения"
                label-for="dateStart"
                label-class="mf-label"
              >
                <a-month-picker
                  v-model="dateStart"
                  :disabled="disabled"
                  format="MM/YYYY"
                  placeholder="Дата"/>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="my-4">
            <b-col md="7">
              <b-table
                id="data_table"
                style="width: 80%"
                hover
                tbody-tr-class="td-centered"
                class="text-center"
                ref="licensesDefault"
                :fields="compensationFieldsDefault"
                :items="compensationModelDefault">
                <template v-slot:cell(tariffPrice)="">
                  <b-form-group
                    :invalid-feedback="getError('Стоимость лицензии')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="tariffPriceDefault-input"
                      name="Стоимость лицензии"
                      v-validate="priceValidation"
                      data-vv-as="Стоимость лицензии"
                      v-model="compensationModelDefault[0].tariffPrice"
                      :disabled="disabled"
                      :state="validateState('Стоимость лицензии')"
                    ></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(percentLicense)="">
                  <b-form-group
                    :invalid-feedback="getError('% от лицензии')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="percentLicense-input"
                      name="% от лицензии"
                      v-validate="priceValidation"
                      data-vv-as="% от лицензии"
                      v-model="compensationModelDefault[0].percentLicense"
                      :disabled="disabled"
                      :state="validateState('% от лицензии')"
                    ></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(percentPackages)="">
                  <b-form-group
                    :invalid-feedback="getError('% от пакетов с превышения')"
                    style="margin-bottom: 0">
                    <div class="d-flex">
                      <b-form-input
                        id="percentPackages-input"
                        name="% от пакетов с превышения"
                        v-validate="{regex: /^\d{0,10}[.]?\d{0,2}?$/}"
                        data-vv-as="% от пакетов с превышения"
                        v-model="compensationModelDefault[0].percentPackages"
                        :disabled="disabled"
                        :state="validateState('% от пакетов с превышения')"
                      ></b-form-input>
                      <b-button :disabled="disabled" @click="recalcPrices" variant="outline-primary" v-b-tooltip title="Рассчитать" class="ml-4"><i class="fas fa-calculator"></i></b-button>
                    </div>
                  </b-form-group>
                </template>
              </b-table>
            </b-col>
            <b-col md="5">
              <b-table
                id="data_table"
                style="width: 30%"
                hover
                tbody-tr-class="td-centered"
                class="text-center"
                ref="compensationRecalc"
                :fields="compensationFieldsRecalc"
                :items="compensationModelRecalc">
                <template v-slot:cell(tariffPrice)="">
                  <b-form-group
                    :invalid-feedback="getError('Вознаграждение от лицензии')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="compensationModelRecalc-input"
                      name="Вознаграждение от лицензии"
                      v-validate="priceValidation"
                      data-vv-as="Вознаграждение от лицензии"
                      v-model="compensationModelRecalc[0].tariffPrice"
                      :disabled="disabled"
                      :state="validateState('Вознаграждение от лицензии')"
                    ></b-form-input>
                  </b-form-group>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row class="my-4">
            <b-col md="7">
              <b-table
                id="data_table"
                style="width: 80%"
                hover
                tbody-tr-class="td-centered"
                class="text-center"
                ref="licensesDefault"
                :fields="accountsFieldsDefault"
                :items="accountsModelDefault">
                <template v-slot:cell(max_free_count)="">
                  <b-form-group
                    :invalid-feedback="getError('Количество учетных записей')"
                    style="margin-bottom: 0">
                    <b-form-input
                      id="maxFreeCount-input"
                      name="Количество учетных записей"
                      v-validate="Boolean((accountsModelDefault[0].accountPercent && (accountsModelDefault[0].accountPercent !== '')) || (accountsModelDefault[0].client_price && (accountsModelDefault[0].client_price !== '')) || (accountsModelRecalc[0].daobit_price && (accountsModelRecalc[0].daobit_price !== ''))) ? priceValidation : accountValidation"
                      data-vv-as="Количество учетных записей"
                      v-model="accountsModelDefault[0].max_free_count"
                      :disabled="disabled"
                      :state="validateState('Количество учетных записей')"
                    ></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(accountPercent)="">
                  <b-form-group
                    :invalid-feedback="getError('% от учетной записи')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="accountPercent-input"
                      name="% от учетной записи"
                      v-validate="Boolean((accountsModelDefault[0].max_free_count && (accountsModelDefault[0].max_free_count !== '')) || (accountsModelDefault[0].client_price && (accountsModelDefault[0].client_price !== '')) || (accountsModelRecalc[0].daobit_price && (accountsModelRecalc[0].daobit_price !== ''))) ? priceValidation : accountValidation"
                      data-vv-as="% от учетной записи"
                      v-model="accountsModelDefault[0].accountPercent"
                      :disabled="disabled"
                      :state="validateState('% от учетной записи')"
                    ></b-form-input>
                  </b-form-group>
                </template>
                <template v-slot:cell(client_price)="">
                  <b-form-group
                    :invalid-feedback="getError('Стоимость учетной записи с превышения')"
                    style="margin-bottom: 0">
                      <div class="d-flex">
                      <b-form-input
                        id="clientPrice-input"
                        name="Стоимость учетной записи с превышения"
                        v-validate="Boolean((accountsModelDefault[0].accountPercent && (accountsModelDefault[0].accountPercent !== '')) || (accountsModelDefault[0].max_free_count && (accountsModelDefault[0].max_free_count !== '')) || (accountsModelRecalc[0].daobit_price && (accountsModelRecalc[0].daobit_price !== ''))) ? priceValidation : accountValidation"
                        data-vv-as="Стоимость учетной записи с превышения"
                        v-model="accountsModelDefault[0].client_price"
                        :disabled="disabled"
                        :state="validateState('Стоимость учетной записи с превышения')"
                      ></b-form-input>
                      <b-button :disabled="disabled" @click="recalcAccounts" variant="outline-primary" v-b-tooltip title="Рассчитать" class="ml-4"><i class="fas fa-calculator"></i></b-button>
                      </div>
                  </b-form-group>
                </template>
              </b-table>
            </b-col>
            <b-col md="5">
              <b-table
                id="data_table"
                style="width: 30%"
                hover
                tbody-tr-class="td-centered"
                class="text-center white-space-no-wrap"
                ref="accountsRecalc"
                :fields="accountsFieldsRecalc"
                :items="accountsModelRecalc">
                <template v-slot:cell(daobit_price)="">
                  <b-form-group
                    :invalid-feedback="getError('Вознаграждение от учетной записи')"
                    style="margin-bottom: 0"
                  >
                    <b-form-input
                      id="accountsRecalc-input"
                      name="Вознаграждение от учетной записи"
                      v-validate="Boolean((accountsModelDefault[0].accountPercent && (accountsModelDefault[0].accountPercent !== '')) || (accountsModelDefault[0].client_price && (accountsModelDefault[0].client_price !== '')) || (accountsModelRecalc[0].max_free_count && (accountsModelRecalc[0].max_free_count !== ''))) ? priceValidation : accountValidation"
                      data-vv-as="Вознаграждение от учетной записи"
                      v-model="accountsModelRecalc[0].daobit_price"
                      :disabled="disabled"
                      :state="validateState('Вознаграждение от учетной записи')"
                    ></b-form-input>
                  </b-form-group>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="7">
              <b-table
                id="data_table"
                ref="pricesDefault"
                hover
                tbody-tr-class="td-centered"
                class="text-center"
                :fields="fieldsDefault"
                :items="modelDefault">
                <template #thead-top="">
                  <b-tr>
                    <b-th colspan="2"></b-th>
                    <b-th colspan="6">Цена пакета с превышения</b-th>
                  </b-tr>
                </template>
                <template #table-colgroup="scope">
                  <col
                    v-for="field in scope.fieldsDefault"
                    :key="field.key">
                </template>
                <template v-slot:cell(packageType)="data" class="package-type-cell">
                  <b-form-group
                    :invalid-feedback="getError('dealer')"
                    style="margin-bottom: 0; width: 185px;">
                    <treeselect
                      id="dealerClient"
                      class="package-type-select"
                      name="dealerClient"
                      :options="packagesTypes"
                      v-model="data.item.packageType"
                      placeholder="Тип"
                      data-vv-as="Тип"
                      :disabled="disabled"
                      v-validate="{required:true}">
                      <div slot="value-label" slot-scope="{ node }">{{ node.raw.caption }}</div>
                    </treeselect>
                  </b-form-group>
                </template>
                <template v-slot:cell()="data">
                  <b-form-group
                    :invalid-feedback="getError(data.field.label + '-' + data.index)"
                    style="margin-bottom: 0">
                    <b-form-input
                      :name="data.field.label + '-' + data.index"
                      v-validate="priceValidation"
                      :data-vv-as="data.field.label + '-' + data.index"
                      v-model="data.item[data.field.key]"
                      :disabled="disabled"
                      :state="validateState(data.field.label + '-' + data.index)"
                    ></b-form-input>
                  </b-form-group>
                </template>
              </b-table>
            </b-col>
            <b-col md="5">
              <b-table
                id="data_table"
                hover
                tbody-tr-class="td-centered"
                class="text-center"
                ref="pricesRecalc"
                :fields="fieldsRecalc"
                :items="modelDefault">
                <template #table-colgroup="scope">
                  <col
                    v-for="field in scope.fieldsRecalc"
                    :key="field.key">
                </template>
               <template #thead-top="">
                  <b-tr>
                    <b-th colspan="6">Вознаграждение от пакета с превышения</b-th>
                  </b-tr>
                </template>
                <template v-slot:head()="data">
                  <div>{{ data.label.replace("пересчет", '') }}</div>
              </template>
                <template v-slot:cell()="data">
                  <b-form-group
                    :invalid-feedback="getError(data.field.label + '-' + data.index)"
                    style="margin-bottom: 0">
                    <b-form-input
                      :name="data.field.label + '-' + data.index"
                      v-validate="priceValidation"
                      :data-vv-as="data.field.label + '-' + data.index"
                      v-model="data.item[data.field.key]"
                      :disabled="disabled"
                      :state="validateState(data.field.label + '-' + data.index)"
                    ></b-form-input>
                  </b-form-group>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
          <b-col md="12" class="mb-4">
            <b-button size="sm" @click="addRow" variant="outline-secondary" :disabled="disabled" class="mr-2"><i class="fas fa-plus mr-1"></i>Добавить запись</b-button>
            <b-button size="sm" @click="removeRow" variant="outline-secondary" :disabled="disabled"><i class="fas fa-minus"></i></b-button>
          </b-col>
        </b-row>
          <b-row class="mb-3 mt-4">
            <b-col xl="6" lg="12" md="12" sm="12" cols="12">
              <div class="d-md-flex d-lg-flex align-items-start">
                <b-button
                  :disabled="veeErrors.any() || (Boolean(dateStart) === false) || disabled"
                  variant="success"
                  type="submit"
                  class="btn-action-success mr-3 mb-2">
                  <span v-if="addPrice">Добавить прайс</span>
                  <span v-else>Изменить прайс</span>
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
    </template>
  </b-sidebar>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { validation } from '../modalForms/validation'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import moment from 'moment'

export default {
  name: 'AddSpecialConditionApiPrice',
  components: {
    Treeselect
  },
  props: ['addPrice', 'startMonth', 'startYear', 'clientId', 'disabled'],
  mixins: [validation],
  data () {
    return {
      sidebarWidth: '',
      clientsModel: null,
      dateStart: null,
      fieldsDefault: [
        { key: 'packageType', label: 'Тип пакета' },
        { key: 'tariffType', label: 'Кол-во пакетов', thStyle: { padding: '2px 2px', verticalAlign: 'middle' } },
        { key: 'rangeDefault1', label: '1-10' },
        { key: 'rangeDefault2', label: '11-20' },
        { key: 'rangeDefault3', label: '21-50' },
        { key: 'rangeDefault4', label: '51-100' },
        { key: 'rangeDefault5', label: '101-200' },
        { key: 'rangeDefault6', label: '200+' }
      ],
      fieldsRecalc: [
        { key: 'rangeRecalc1', label: '1-10 пересчет' },
        { key: 'rangeRecalc2', label: '11-20 пересчет' },
        { key: 'rangeRecalc3', label: '21-50 пересчет' },
        { key: 'rangeRecalc4', label: '51-100 пересчет' },
        { key: 'rangeRecalc5', label: '101-200 пересчет' },
        { key: 'rangeRecalc6', label: '200+ пересчет' }
      ],
      modelDefault: [
        {
          packageType: null,
          tariffType: null,
          rangeDefault1: null,
          rangeDefault2: null,
          rangeDefault3: null,
          rangeDefault4: null,
          rangeDefault5: null,
          rangeDefault6: null,
          rangeRecalc1: null,
          rangeRecalc2: null,
          rangeRecalc3: null,
          rangeRecalc4: null,
          rangeRecalc5: null,
          rangeRecalc6: null
        }
      ],
      freezeModelDefault: null,
      compensationFieldsDefault: [
        { key: 'tariffPrice', label: 'Стоимость лицензии' },
        { key: 'percentLicense', label: '% от лицензии' },
        { key: 'percentPackages', label: '% от пакетов с превышения' }
      ],
      compensationModelDefault: [
        { tariffPrice: null, percentLicense: null, percentPackages: null }
      ],
      freezeAccountsDefault: null,
      accountsFieldsDefault: [
        { key: 'max_free_count', label: 'Количество учетных записей' },
        { key: 'accountPercent', label: '% от учетной записи' },
        { key: 'client_price', label: 'Стоимость учетной записи с превышения' }
      ],
      accountsModelDefault: [
        { max_free_count: null, client_price: null, daobit_price: null }
      ],
      freezeСompensationModelDefault: null,
      compensationFieldsRecalc: [{ key: 'tariffPrice', label: 'Вознаграждение от лицензии' }],
      compensationModelRecalc: [{ tariffPrice: null }],
      freezeСompensationModelRecalc: null,
      accountsFieldsRecalc: [{ key: 'daobit_price', label: 'Вознаграждение от учетной записи' }],
      accountsModelRecalc: [{ daobit_price: null }],
      freezeAccountsModelRecalc: null
    }
  },
  computed: {
    ...mapState(
      {
        mobile: state => state.mobile,
        tablet: state => state.tablet,
        desktop: state => state.desktop,
        largeDesktop: state => state.largeDesktop,
        dealerPriceData: state => state.dealers.dealerPriceData,
        dealerClients: state => state.dealers.dealerClients,
        messagePricePositions: state => state.dealers.messagePricePositions
      }
    ),
    packagesTypes () {
      return this.messagePricePositions ? this.messagePricePositions.api : null
    }
  },
  mounted () {
    this.calcSidebarWidth()
  },
  methods: {
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    calcSidebarWidth () {
      if (this.largeDesktop) {
        this.sidebarWidth = '100%'
      } else if (this.desktop) {
        this.sidebarWidth = '100%'
      } else if (this.mobile || this.tablet) {
        this.sidebarWidth = '100%'
      }
    },
    percentage (percent, total) {
      return ((percent / 100) * total).toFixed(2)
    },
    recalcPrices () {
      this.modelDefault.map((item) => {
        item.rangeRecalc1 = item.rangeDefault1 && this.compensationModelDefault[0].percentPackages ? parseFloat(this.percentage(this.compensationModelDefault[0].percentPackages, item.rangeDefault1)) : null
        item.rangeRecalc2 = item.rangeDefault2 && this.compensationModelDefault[0].percentPackages ? parseFloat(this.percentage(this.compensationModelDefault[0].percentPackages, item.rangeDefault2)) : null
        item.rangeRecalc3 = item.rangeDefault2 && this.compensationModelDefault[0].percentPackages ? parseFloat(this.percentage(this.compensationModelDefault[0].percentPackages, item.rangeDefault3)) : null
        item.rangeRecalc4 = item.rangeDefault2 && this.compensationModelDefault[0].percentPackages ? parseFloat(this.percentage(this.compensationModelDefault[0].percentPackages, item.rangeDefault4)) : null
        item.rangeRecalc5 = item.rangeDefault2 && this.compensationModelDefault[0].percentPackages ? parseFloat(this.percentage(this.compensationModelDefault[0].percentPackages, item.rangeDefault5)) : null
        item.rangeRecalc6 = item.rangeDefault2 && this.compensationModelDefault[0].percentPackages ? parseFloat(this.percentage(this.compensationModelDefault[0].percentPackages, item.rangeDefault6)) : null
      })
      this.compensationModelRecalc[0].tariffPrice = this.compensationModelDefault[0].tariffPrice && this.compensationModelDefault[0].percentLicense ? parseFloat(this.percentage(this.compensationModelDefault[0].percentLicense, this.compensationModelDefault[0].tariffPrice)) : null
    },
    recalcAccounts () {
      this.accountsModelRecalc[0].daobit_price = this.accountsModelDefault[0].client_price && this.accountsModelDefault[0].accountPercent ? parseFloat(this.percentage(this.accountsModelDefault[0].accountPercent, this.accountsModelDefault[0].client_price)) : null
    },
    getData () {
      this.getDealerClients({ id: this.$route.params.id })
      this.getMessagePricePositions()
      this.freezeModelDefault = JSON.parse(JSON.stringify(this.modelDefault))
      this.freezeСompensationModelDefault = JSON.parse(JSON.stringify(this.compensationModelDefault))
      this.freezeAccountsDefault = JSON.parse(JSON.stringify(this.accountsModelDefault))
      this.freezeСompensationModelRecalc = JSON.parse(JSON.stringify(this.compensationModelRecalc))
      this.freezeAccountsModelRecalc = JSON.parse(JSON.stringify(this.accountsModelRecalc))
      if (!this.addPrice) {
        this.getDealerSpecPrice({ month: this.startMonth, year: this.startYear, client_id: this.clientId, type: 'api' }).then(
          () => {
            const dt = this.startYear + '-' + (this.startMonth.length > 0 ? this.startMonth : ('0' + this.startMonth)) + '-' + '01'
            this.dateStart = moment(dt)
            this.clientsModel = this.clientId
            if (this.dealerPriceData.accounts) {
              this.accountsModelDefault[0].max_free_count = this.dealerPriceData.accounts.max_free_count
              this.accountsModelDefault[0].client_price = this.dealerPriceData.accounts.client_price
              this.accountsModelRecalc[0].daobit_price = this.dealerPriceData.accounts.daobit_price
            }
            this.compensationModelDefault[0].tariffPrice = this.dealerPriceData.client_price
            this.compensationModelRecalc[0].tariffPrice = this.dealerPriceData.daobit_price
            this.modelDefault = []
            this.dealerPriceData.packages.map((item) => {
              this.modelDefault.push({
                packageType: item.message_price_position_alias,
                tariffType: item.threshold,
                rangeDefault1: item.client_points_cost[0],
                rangeDefault2: item.client_points_cost[1],
                rangeDefault3: item.client_points_cost[2],
                rangeDefault4: item.client_points_cost[3],
                rangeDefault5: item.client_points_cost[4],
                rangeDefault6: item.client_points_cost[5],
                rangeRecalc1: item.daobit_points_cost[0],
                rangeRecalc2: item.daobit_points_cost[1],
                rangeRecalc3: item.daobit_points_cost[2],
                rangeRecalc4: item.daobit_points_cost[3],
                rangeRecalc5: item.daobit_points_cost[4],
                rangeRecalc6: item.daobit_points_cost[5]
              })
            })
            this.calcPackagesPercent()
            this.calcLicensePercent()
            this.calcAccountsPercent()
          }
        )
      }
    },
    async saveFormData () {
      const modelDefaultArr = this.modelDefault.map((item) => {
        if (Object.values(item).some(x => x)) {
          return {
            message_price_position_alias: item.packageType,
            threshold: parseFloat(item.tariffType),
            client_points_cost: [parseFloat(item.rangeDefault1), parseFloat(item.rangeDefault2), parseFloat(item.rangeDefault3), parseFloat(item.rangeDefault4), parseFloat(item.rangeDefault5), parseFloat(item.rangeDefault6)],
            daobit_points_cost: [parseFloat(item.rangeRecalc1), parseFloat(item.rangeRecalc2), parseFloat(item.rangeRecalc3), parseFloat(item.rangeRecalc4), parseFloat(item.rangeRecalc5), parseFloat(item.rangeRecalc6)]
          }
        } else return null
      })
      this.accountsModelDefault[0].daobit_price = this.accountsModelRecalc[0].daobit_price
      const data = {
        year: this.addPrice ? this.dateStart.toDate().getFullYear() : this.startYear,
        month: this.addPrice ? this.dateStart.toDate().getMonth() + 1 : this.startMonth,
        year_new: this.dateStart.toDate().getFullYear(),
        month_new: this.dateStart.toDate().getMonth() + 1,
        client_id: this.clientsModel,
        client_price: this.compensationModelDefault[0].tariffPrice ? parseFloat(this.compensationModelDefault[0].tariffPrice) : null,
        daobit_price: this.compensationModelRecalc[0].tariffPrice ? parseFloat(this.compensationModelRecalc[0].tariffPrice) : null,
        accounts: Object.values(this.accountsModelDefault[0]).every(x => x === null || x === '') ? null : this.accountsModelDefault[0]
      }
      if (modelDefaultArr[0]) data.packages = modelDefaultArr
      if (this.addPrice) {
        this.saveDealerSpecPrice({ data: data, type: 'api' }).then(
          () => {
            this.getDealerSpecialPrices({ id: this.$route.params.id })
            this.$refs.apiSpecPriceSidebar.hide()
          }
        )
      } else {
        this.updateDealerSpecPrice({ data: data, type: 'api' }).then(
          () => {
            this.getDealerSpecialPrices({ id: this.$route.params.id })
            this.$refs.apiSpecPriceSidebar.hide()
          }
        )
      }
    },
    calcPackagesPercent () {
      const percents = []
      this.dealerPriceData.packages.map((item) => {
        for (let i = 0; i < item.client_points_cost.length; i++) {
          const percent = parseFloat((item.daobit_points_cost[i] * 100 / item.client_points_cost[i]).toFixed(2))
          percents.push(percent)
        }
      })
      const counts = {}
      percents.forEach(function (x) { counts[x] = (counts[x] || 0) + 1 })
      this.compensationModelDefault[0].percentPackages = Object.keys(counts)[0]
    },
    calcLicensePercent () {
      const percents = []
      percents.push(parseFloat((this.dealerPriceData.daobit_price * 100 / this.dealerPriceData.client_price).toFixed(2)))
      const counts = {}
      percents.forEach(function (x) { counts[x] = (counts[x] || 0) + 1 })
      this.compensationModelDefault[0].percentLicense = Object.keys(counts)[0]
    },
    calcAccountsPercent () {
      const percents = []
      if (this.dealerPriceData.accounts && this.dealerPriceData.accounts.daobit_price && this.dealerPriceData.accounts.client_price) {
        percents.push(parseFloat((this.dealerPriceData.accounts.daobit_price * 100 / this.dealerPriceData.accounts.client_price).toFixed(2)))
        const counts = {}
        percents.forEach(function (x) { counts[x] = (counts[x] || 0) + 1 })
        this.accountsModelDefault[0].accountPercent = Object.keys(counts)[0]
      }
    },
    addRow () {
      this.modelDefault.push({
        packageType: null,
        tariffType: null,
        rangeDefault1: null,
        rangeDefault2: null,
        rangeDefault3: null,
        rangeDefault4: null,
        rangeDefault5: null,
        rangeDefault6: null,
        rangeRecalc1: null,
        rangeRecalc2: null,
        rangeRecalc3: null,
        rangeRecalc4: null,
        rangeRecalc5: null,
        rangeRecalc6: null
      })
    },
    removeRow () {
      if (this.modelDefault.length > 1) {
        this.modelDefault.splice((this.modelDefault.length - 1), 1)
      }
    },
    resetSidebarData () {
      this.$validator.pause()
      this.$nextTick(() => {
        this.$validator.errors.clear()
        this.$validator.fields.items.forEach(field => field.reset())
        this.$validator.fields.items.forEach(field => this.errors.remove(field))
        this.$validator.resume()
      })
      setTimeout(() => {
        this.dateStart = null
        this.clientsModel = null
        this.modelDefault = this.freezeModelDefault
        this.compensationModelDefault = this.freezeСompensationModelDefault
        this.compensationModelRecalc = this.freezeСompensationModelRecalc
        this.accountsModelDefault = this.freezeAccountsDefault
        this.accountsModelRecalc = this.freezeAccountsModelRecalc
        this.setPrice(null)
      }, 200)
    },
    ...mapActions('dealers', [
      'saveDealerSpecPrice',
      'getDealerSpecialPrices',
      'updateDealerSpecPrice',
      'getDealerSpecPrice',
      'getDealerClients',
      'getMessagePricePositions'
    ]),
    ...mapMutations('dealers', [
      'setPrice'
    ])
  }
}
</script>

<style scoped>
  h2 {
    margin-bottom: 20px;
    margin-top: 10px;
    color: #37474F;
    font-size: 25px;
    font-weight: 500;
    line-height: 28px;
  }
  .form-control.is-valid {
    padding: 0.375rem 0.75rem !important;
  }
  .form-control.is-invalid {
    padding: 0.375rem 0.75rem !important;
  }
  .form-control:disabled {
    background-color: #f5f5f5;
  }
</style>
